/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 7:52 PM
 *
 */

import { useQuery } from 'react-query';

import { getOtherFieldsList } from 'features/members/api/requests/member.request';

export const useGetOtherFieldsList = () => {
  return useQuery(['other_fields-list'], () => getOtherFieldsList(), {
    retry: false,
    staleTime: Infinity,
  });
};
